export default __webpack_public_path__ + "static/media/distribucion-01.1def8fcb.png";